import EmpresaMapper from "@/common/contabil/EmpresaMapperAdapter";
import { ITributosAcumuladosResponse } from "../requests/types";

export default class TributosAcumulados {
  constructor(readonly response: ITributosAcumuladosResponse | undefined) {}

  getSeries() {
    return this.response?.empresas.map((empresa) => {
      const previsao = this.response?.previsoesPorEmpresas?.find(
        (previsao) => previsao.id === empresa.id
      );

      return {
        pis: empresa.totalPis || 0,
        confins: empresa.totalCofins || 0,
        simples: empresa.totalSimples || 0,
        nomeFantasia: empresa.nomeFantasia,
        empresa: EmpresaMapper.toEntity(empresa),
        previsao: previsao
      };
    });
  }

  getCNPJs() {
    return this.response?.empresas.map((empresa) => empresa.cnpj.completo);
  }

  getLojaMaisPagou() {
    return this.response?.empresaQueMaisPagou;
  }

  getValoresAcumulados(): number {
    const tributos = this.response?.tributoAcumuladoAno;

    return tributos || 0;
  }
}
